import ReportMoPartner from "../../pages/Reports/ReportMoPartner";
import ReportMoAdmin from "../../pages/ReportsAdmin/ReportMoAdmin";
import ReportSmsSummaryAdmin from "../../pages/ReportsAdmin/ReportSmsSummaryAdmin";
import ReportPortabilidadAdmin from "../../pages/ReportsAdmin/ReportPortabilidadAdmin";
import ReportSmsByDateAdmin from "../../pages/ReportsAdmin/ReportSmsByDateAdmin";
import ReportCustomerCarrierAdmin from "../../pages/ReportsAdmin/ReportCustomerCarrierAdmin";
import ReportCampaignSmsAdmin from "../../pages/ReportsAdmin/ReportCampaignSmsAdmin";
import ReportFiles from "../../pages/Reports/ReportFiles";
import ReportSmsSummaryByCarrier from "../../pages/Reports/ReportSmsSummaryByCarrier";
import ReportSmsSummary from "../../pages/Reports/ReportSmsSummary";
import ReportSmsSummaryByUser from "../../pages/Reports/ReportSmsSummaryByUser";
import ReportExternalCampaings from "../../pages/ReportsAdmin/ReportExternalCampaings";
import ReportExternalCampaignsPartner from "../../pages/Reports/ReportExternalCampaignsPartner";
import ReportUser from "../../pages/Reports/ReportUser";
import ReportDate from "../../pages/Reports/ReportSmsByDatePeriod";
import ReportCampaigns from "../../pages/ReportsAdmin/ReportCampaigns";
import ReportCustomerSmryMultichannel from "../../pages/ReportsAdmin/ReportCustomerSmryMultichannel";
import { createProtectedRoutes } from "../../utils/createdProtectedRoutes";
import ConciliationExternalCampaign from "../../pages/ReportsAdmin/ConciliationExternalCampaign";
import RCSLogs from "../../pages/Reports/rcs/RCSLogs";
import _ReportsAdmin from "../../pages/ReportsAdmin/_Reports";
import _ReportsByPartners from "../../pages/ReportsAdmin/rcs/_ReportsByPartners";
import _ReportsByCustomers from "../../pages/ReportsAdmin/rcs/_ReportsByCustomers";
import _ReportsSmryByPartners from "../../pages/Reports/rcs/_ReportsSmryByPartners";
export const ROUTE_REPORT = "Reports";
const ROUTE_ADMIN_REPORT = "AdminReports";

const routesConfig = [
  {
    path: `${ROUTE_REPORT}/ReportMoDate`,
    component: ReportMoPartner,
    roles: [1, 2, 3],
  },
  {
    path: `${ROUTE_ADMIN_REPORT}/Mo`,
    component: ReportMoAdmin,
    roles: [1, 4, 5],
  },
  {
    path: `${ROUTE_ADMIN_REPORT}/Sms`,
    component: ReportSmsSummaryAdmin,
    roles: [1, 4, 5],
  },
  {
    path: `${ROUTE_ADMIN_REPORT}/Portabilidad`,
    component: ReportPortabilidadAdmin,
    roles: [1, 4, 5],
  },
  {
    path: `${ROUTE_ADMIN_REPORT}/Smsdetail`,
    component: ReportSmsByDateAdmin,
    roles: [1, 4, 5],
  },
  {
    path: `${ROUTE_ADMIN_REPORT}/SummaryCarrier`,
    component: ReportCustomerCarrierAdmin,
    roles: [1, 4, 5],
  },
  {
    path: `${ROUTE_ADMIN_REPORT}/campaigns`,
    component: ReportCampaignSmsAdmin,
    roles: [1, 4, 5],
  },
  {
    path: `${ROUTE_REPORT}/ReportSmsSmryCarrier`,
    component: ReportSmsSummaryByCarrier,
    roles: [1, 2, 3],
  },
  {
    path: `${ROUTE_REPORT}/ReportSmsSmry`,
    component: ReportSmsSummary,
    roles: [1, 2, 3],
  },
  {
    path: `${ROUTE_REPORT}/ReportSmsSmryUser`,
    component: ReportSmsSummaryByUser,
    roles: [1, 2, 3],
  },
  {
    path: `${ROUTE_ADMIN_REPORT}/CampaignsExt`,
    component: ReportExternalCampaings,
    roles: [1, 4, 5],
  },
  {
    path: `${ROUTE_REPORT}/ExternalCamp`,
    component: ReportExternalCampaignsPartner,
    roles: [1, 2, 3],
  },
  {
    path: `${ROUTE_REPORT}/ReportUser`,
    component: ReportUser,
    roles: [1, 2, 3],
  },
  {
    path: `${ROUTE_REPORT}/ReportDate`,
    component: ReportDate,
    roles: [1, 2, 3],
  },
  {
    path: `${ROUTE_REPORT}/ReportsUser`,
    component: ReportFiles,
    roles: [1, 2, 3],
  },
  {
    path: `${ROUTE_ADMIN_REPORT}/ExternalCampaignsDetail`,
    component: ReportCampaigns,
    roles: [1],
  },
  {
    path: `${ROUTE_ADMIN_REPORT}/ConciliationCampaignsDetail`,
    component: ConciliationExternalCampaign,
    roles: [1],
  },
  {
    path: `${ROUTE_ADMIN_REPORT}/customersmrymultichannel`,
    component: ReportCustomerSmryMultichannel,
    roles: [1],
  },
  {
    path: `Reports`,
    component: _ReportsAdmin,
    roles: [2, 3],
  },
  {
    path: `AdminReports`,
    component: _ReportsAdmin,
    roles: [1],
  },
];

const rcsReports = [
  {
    path: `Reports/rcs/logs`,
    component: RCSLogs,
    roles: [1, 2, 3],
  },
  {
    path: "/Reports/rcs/partners",
    component: _ReportsSmryByPartners,
    roles: [2, 3],
  },
  {
    path: `AdminReports/rcs/summary-partners`,
    component: _ReportsByPartners,
    roles: [1],
  },
  {
    path: `AdminReports/rcs/summary-customers`,
    component: _ReportsByCustomers,
    roles: [1],
  },
];

const reportRoutes = createProtectedRoutes([...routesConfig, ...rcsReports]);

export default reportRoutes;
